module.exports = __webpack_public_path__ + "img/bodenschutz.1b721fa.png";